// extracted by mini-css-extract-plugin
export default {"image":"MapComponent_image__+1NCQ"};